import { useState } from 'react';

import Button from '@/componentsv2/Button';

import type { HoursSubmissionView } from '../viewModel';
import ConfirmActions from './ConfirmActions';
import HoursFullWidthCell from './HoursFullWidthCell';
import ResolveExpander from './ResolveExpander';

export type HoursRowAction = 'confirm' | 'resolve';

interface HoursRowActionsProps {
  action: HoursRowAction;
  row: HoursSubmissionView;
  columnCount: number;
  maxConfirmableHours: number;
  expertName: string;
}

/**
 * A row's actions, in a full-width row under it rather than in a cell as the
 * prototype has them: the confirm and resolve forms need the width. Resolve
 * starts as a button that the expander replaces.
 */
export default function HoursRowActions({
  action,
  row,
  columnCount,
  maxConfirmableHours,
  expertName,
}: HoursRowActionsProps): JSX.Element {
  const [resolving, setResolving] = useState(false);

  return (
    <tr className="border-b border-surface-border">
      <HoursFullWidthCell colSpan={columnCount}>
        {action === 'confirm' ? (
          <ConfirmActions
            submissionId={row.id}
            expertName={expertName}
            hoursSubmitted={row.hoursSubmitted}
            maxConfirmableHours={maxConfirmableHours}
          />
        ) : resolving ? (
          <ResolveExpander
            submissionId={row.id}
            hoursSubmitted={row.hoursSubmitted}
            maxConfirmableHours={maxConfirmableHours}
            onDone={() => setResolving(false)}
          />
        ) : (
          <div className="flex justify-end">
            <Button variant="secondary" size="small" onClick={() => setResolving(true)}>
              Resolve dispute
            </Button>
          </div>
        )}
      </HoursFullWidthCell>
    </tr>
  );
}
